import { render, staticRenderFns } from "./AddTrainingDetails.vue?vue&type=template&id=48009e6f&scoped=true"
import script from "./AddTrainingDetails.vue?vue&type=script&lang=js"
export * from "./AddTrainingDetails.vue?vue&type=script&lang=js"
import style0 from "./AddTrainingDetails.vue?vue&type=style&index=0&id=48009e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48009e6f",
  null
  
)

export default component.exports